import styled from 'styled-components';

import BREAKPOINTS from 'styles/breakpoints';
import COLORS from 'styles/colors';
import { rotate } from 'styles/animations';

const Container = styled.div`
  padding: 20px 0;
  width: 100%;
  text-align: center;

  ${BREAKPOINTS.small`
    padding: 50px 0 0;
  `}
`;

const Svg = styled.svg`
  animation: ${rotate} 1s linear infinite;
`;

const LoadingSpinner = ({
  size = 40,
  stroke = 2,
  strokeColor = 'pinkMillennial',
}) => {
  const percentOfCircle = 84;
  const center = size / 2;
  const radius = size / 2 - stroke / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = ((100 - percentOfCircle) / 100) * circumference;
  return (
    <Container>
      <Svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <circle
          stroke={COLORS[strokeColor]}
          cx={center}
          cy={center}
          r={radius}
          strokeWidth={stroke}
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
        />
      </Svg>
    </Container>
  );
};

export default LoadingSpinner;
